import { Component, Input } from '@angular/core';
import { formatDate } from '@angular/common';
import { DealerPortalService } from 'src/app/services/dealerPortal.service';

@Component({
  selector: 'app-marketing-activity-card',
  templateUrl: './marketing-activity-card.component.html',
  styleUrls: ['./marketing-activity-card.component.less']
})
export class MarketingActivityCardComponent {
  @Input() data: any;
  isVisible = false;
  modalVisible = false;
  selectedItem: any;
  approvalStatus = '';
  comment = '';
  isAttachmentVisible = false;
  verifyCode = '3268662558';
  invoiceData = {
    verificationNo: '3268662558',
    orders: [
      {
        orderNo: '0206541580415',
        type: '增值税专用发票',
        amount: 56800.26,
        status: '状态名称',
        expressNo: 'SF02262626'
      },
      {
        orderNo: '105501515151',
        type: '增值税专用发票',
        amount: 56800.26,
        status: '状态名称',
        expressNo: 'SF01501066'
      },
      {
        orderNo: '105501515151',
        type: '增值税专用发票',
        amount: 56800.26,
        status: '状态名称',
        expressNo: 'SF01501066'
      }
    ]
  };

  constructor(
    private dealerPortalService: DealerPortalService) { }

  statusClass(status: string) {
    switch (status) {
      case 'done': return 'bg-green-100 text-green-700';
      case 'processing': return 'bg-blue-100 text-blue-700';
      case 'pending': return 'bg-yellow-100 text-yellow-700';
      default: return 'bg-gray-100 text-gray-600';
    }
  }
  getColorByStatus(status: string, isBackground: boolean, isBorder: boolean): string {
    let color = "";
    switch (status) {
      case "待审批":
      case "待上传附件":
      case "开票中":
        color = isBackground ? "#FEF5E9" : (isBorder ? "#F6C172" : "#F19F23");
        break;
      case "付款中":
        color = isBackground ? "#F9F2F9" : (isBorder ? "#C279BE" : "#9E2896");
        break;
      case "已完成":
        color = isBackground ? "#F1F8F7" : (isBorder ? "#84BDBA" : "#18837E");
        break;
      case "核销中":
        color = isBackground ? "#F0FAFF" : (isBorder ? "#F0FAFF" : "#007BC0");
        break;
      default:
        color = isBackground ? "#F2F3F4" : (isBorder ? "#B2B9C0" : "#A0A0A0");
        break;
    }
    return color;
  }

  formatMoney(value: any, decimals = 2): string {
    if (value === null || value === undefined || value === '' || value === 0) {
      return '-';
    }

    const num = Number(value);
    if (isNaN(num)) {
      return String(value);
    }

    return num
      .toFixed(decimals)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  getColorByApprovalStatus(status: string, isBackground: boolean, isBorder: boolean): string {
    let color = "";
    switch (status) {
      case "审批中":
        color = isBackground ? "#FEF5E9" : (isBorder ? "#F6C172" : "#F19F23");
        break;
      case "审批拒绝":
        color = isBackground ? "#F9F2F9" : (isBorder ? "#C279BE" : "#9E2896");
        break;
      case "审批通过":
        color = isBackground ? "#F1F8F7" : (isBorder ? "#84BDBA" : "#18837E");
        break;
      case "撤回":
        color = isBackground ? "#F2F3F4" : (isBorder ? "#B2B9C0" : "#A0A0A0");
        break;
      default:
        color = isBackground ? "#F2F3F4" : (isBorder ? "#B2B9C0" : "#A0A0A0");
        break;
    }
    return color;
  }

  showModal(): void {
    this.isVisible = true;
  }

  handleCancel(): void {
    this.isVisible = false;
  }
  openAttachmentModel() {
    this.isAttachmentVisible = true;
  }

  handleCancelAttachmentModel() {
    this.isAttachmentVisible = false;
  }

  formatDisplayDate(
    value: any,
    pattern: string = 'yyyy.MM.dd',
    locale: string = 'en-US',
    placeholder: string = '--'
  ): string {
    if (!value || value === placeholder) return placeholder;

    // 尝试转换为 Date 对象
    const date = new Date(value);
    if (isNaN(date.getTime())) return placeholder;

    try {
      return formatDate(date, pattern, locale);
    } catch {
      return placeholder;
    }
  }

  formatActualPayDate(value: any): string {
    if (value !== null && value !== '--') {
      const year = value.substring(0, 4);
      const month = value.substring(4, 6);
      const day = value.substring(6, 8);
      return `${year}.${month}.${day}`;
    } else {
      return '--';
    }

  }

  getFilenameFromUrl(url: string): string {
    if (!url) return '';
    try {
      const parsedUrl = new URL(url);
      return parsedUrl.pathname.split('/').pop() || '';
    } catch {
      return url.split('/').pop() || '';
    }
  }

  isAttachmentExist() {
    const fields = [
      'tripartiteAgreement',
      'adServiceAgreement',
      'websiteScreenshot',
      'salesTargetScreenshot',
      'eventPhotos',
      'storePhotos',
      'dealerSummary',
      'invoiceFile'
    ];

    return fields.some(key => {
      const value = this.data?.[key];
      return Array.isArray(value) && value.length > 0;
    });
  }

  isAttachmentFileExist(attachment: any) {
    return Array.isArray(attachment) && attachment.length > 0;
  }

  onReview(item: any, approvalStatus: string) {
    this.modalVisible = true;
    this.selectedItem = item;
    this.approvalStatus = approvalStatus;
  }

  handleCancelConfirm() {
    this.modalVisible = false;
  }

  handleConfirm() {
    const param = {
      id: this.selectedItem?.marketingFormId,
      action: this.approvalStatus,
      comment: this.comment
    }
    console.log('param', param)
    this.dealerPortalService.syncMarketingStatus(param);
    this.modalVisible = false;
    this.comment = '';
  }
}
